"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = exports.default = void 0;
var _CouponInput = require("../../components/CouponInput/CouponInput");
var _reactRedux = require("react-redux");
var _reactI18next = require("react-i18next");
var _labeling = _interopRequireDefault(require("../labeling"));
var mapStateToProps = function mapStateToProps(state) {
  return {
    couponLoading: state.order.isCouponLoading,
    couponDetails: state.order.couponDetails,
    orderId: state.order.order.id
  };
};
exports.mapStateToProps = mapStateToProps;
var _default = (0, _reactI18next.withTranslation)()((0, _labeling.default)()((0, _reactRedux.connect)(mapStateToProps)(_CouponInput.PureCouponInput)));
exports.default = _default;